module.exports = __webpack_public_path__ + "assets/RetinaNarr-ThinItalic.f0ddea71df05992123dbd722e60995a6.woff2";